import { Theme } from "@mui/material/styles";

export default function Menu(theme: Theme) {
    return {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    paddingTop: theme.spacing(1.125),
                    paddingRight: theme.spacing(2.5),
                    paddingBottom: theme.spacing(1.125),
                    paddingLeft: theme.spacing(2.5),
                    position: "relative",
                    zIndex: 2,
                    "&.Mui-selected": {
                        backgroundColor: theme.palette.action.selected,
                        "&:hover": {
                            backgroundColor: theme.palette.action.hover,
                        },
                    },
                    // "&+.MuiDivider-root": {
                    //     borderStyle: "solid",
                    // },
                },
            },
        },
    };
}
